(() => {
  const slugify = (value = '') => String(value).toLowerCase().trim().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const escapeText = (value = '') => String(value).replace(/<[^>]*>/g, ' ');

  function classify(product, collectionHandle) {
    const productTags = Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || '');
    const text = `${product.title || ''} ${escapeText(product.body_html || '')} ${product.product_type || ''} ${productTags}`.toLowerCase();
    let type = collectionHandle;
    if (/earring|stud|hoop|jhumka|dangler/.test(text)) type = 'earrings';
    else if (/necklace|pendant|lariat/.test(text)) type = 'necklaces';
    else if (/bracelet|bangle|cuff/.test(text)) type = 'bracelets';
    else if (/anklet/.test(text)) type = 'anklets';
    else if (/\bset\b|combo/.test(text)) type = 'jewellery-sets';
    else if (/ring/.test(text)) type = 'rings';

    let material = 'stainless-steel';
    if (/\bbrass\b/.test(text)) material = 'brass';
    if (/\balloy\b|zinc/.test(text)) material = 'alloy';

    let style = 'dainty';
    if (/earring set/.test(text)) style = 'earrings-set';
    else if (/hoop|huggie/.test(text)) style = 'hoops';
    else if (/jhumka/.test(text)) style = 'kashmiri-jhumkas';
    else if (/dangler|tassel/.test(text)) style = 'danglers';
    else if (/drop/.test(text)) style = 'drops';
    else if (/stud/.test(text)) style = 'studs';
    else if (/layer/.test(text)) style = 'layered';
    else if (/pearl/.test(text)) style = 'pearl';
    else if (/lariat/.test(text)) style = 'lariat';
    else if (/station/.test(text)) style = 'station';
    else if (/pendant/.test(text)) style = 'pendant';
    else if (/tennis/.test(text)) style = 'tennis';
    else if (/cuff/.test(text)) style = 'cuff';
    else if (/bangle/.test(text)) style = 'bangles';
    else if (/charm/.test(text)) style = 'charm';
    else if (/solitaire/.test(text)) style = 'solitaire';
    else if (/stack|band/.test(text)) style = 'stackable';
    else if (/statement|royal|regal|halo|crystal|bloom/.test(text)) style = 'statement';
    else if (/bead/.test(text)) style = 'beaded';
    else if (/chain/.test(text)) style = 'chain';

    const size = /adjustable|open ring|open-ring|one size/.test(text) ? 'adjustable' : 'standard';
    return { type, material, style, size };
  }

  function priceText(value, currency = 'INR') {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
      style: 'currency', currency, maximumFractionDigits: 0
    }).format(Number(value || 0));
  }

  function createCard(product) {
    const variant = product.variants?.find((item) => item.available) || product.variants?.[0] || {};
    const price = Number(variant.price || 0);
    const compare = Number(variant.compare_at_price || 0);
    const productUrl = `/products/${product.handle}`;
    const article = document.createElement('article');
    article.className = 'product-card';
    article.dataset.productCard = '';

    const media = document.createElement('div');
    media.className = 'product-media';
    const imageLink = document.createElement('a');
    imageLink.href = productUrl;
    const image = document.createElement('img');
    image.src = product.images?.[0]?.src || '';
    image.alt = product.title || '';
    image.loading = 'lazy';
    image.width = 900;
    image.height = 1100;
    imageLink.append(image);
    media.append(imageLink);
    if (compare > price) {
      const badge = document.createElement('span');
      badge.className = 'badge';
      badge.textContent = 'Sale';
      media.append(badge);
    }
    const heart = document.createElement('button');
    heart.className = 'heart';
    heart.type = 'button';
    heart.dataset.refWishlist = '';
    heart.setAttribute('aria-label', `Add ${product.title} to wishlist`);
    heart.textContent = '♡';
    let saved = [];
    try { saved = JSON.parse(localStorage.getItem('ira-wishlist') || '[]'); } catch (_) {}
    heart.classList.toggle('active', saved.includes(productUrl));
    heart.addEventListener('click', () => {
      saved = saved.includes(productUrl) ? saved.filter((item) => item !== productUrl) : [...saved, productUrl];
      localStorage.setItem('ira-wishlist', JSON.stringify(saved));
      heart.classList.toggle('active', saved.includes(productUrl));
    });
    media.append(heart);

    const info = document.createElement('a');
    info.className = 'product-info';
    info.href = productUrl;
    const heading = document.createElement('h3');
    heading.textContent = product.title || '';
    const stars = document.createElement('div');
    stars.className = 'stars';
    stars.textContent = '★ 4.9 (4)';
    const pricing = document.createElement('p');
    const strong = document.createElement('strong');
    strong.textContent = priceText(price);
    pricing.append(strong);
    if (compare > price) {
      const strike = document.createElement('s');
      strike.textContent = priceText(compare);
      pricing.append(' ', strike);
    }
    info.append(heading, stars, pricing);
    const view = document.createElement('a');
    view.className = 'card-add';
    view.href = productUrl;
    view.textContent = 'View piece →';
    article.append(media, info, view);
    return article;
  }

  function init(root) {
    if (root.dataset.catalogReady === 'true') return;
    root.dataset.catalogReady = 'true';
    const filters = [...root.querySelectorAll('[data-ref-client-filter]')];
    const grid = root.querySelector('[data-ref-catalog-grid]');
    const count = root.querySelector('[data-ref-catalog-count]');
    const status = root.querySelector('[data-ref-catalog-status]');
    if (!filters.length || !grid) return;
    const collectionHandle = root.dataset.collectionHandle;
    const styleFilters = filters.filter((filter) => filter.dataset.refClientFilter === 'style');
    const categoryTabs = [...document.querySelectorAll('[data-ref-category-tab]')]
      .filter((tab) => tab.dataset.refCategoryCollection === collectionHandle);
    const originalMarkup = grid.innerHTML;
    const originalCount = count?.textContent || '';
    let productsPromise;

    const loadProducts = () => {
      if (!productsPromise) {
        const handle = root.dataset.collectionHandle;
        productsPromise = fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250`)
          .then((response) => {
            if (!response.ok) throw new Error('Unable to load collection products');
            return response.json();
          })
          .then((payload) => payload.products || []);
      }
      return productsPromise;
    };

    const updateCounts = () => {
      ['style', 'material', 'size'].forEach((kind) => {
        const active = filters.filter((filter) => filter.dataset.refClientFilter === kind && filter.checked).length;
        const badge = root.querySelector(`[data-ref-client-filter-count="${kind}"]`);
        if (badge) {
          badge.textContent = String(active);
          badge.hidden = active === 0;
        }
      });
    };

    const syncCategoryTabs = () => {
      if (!categoryTabs.length) return;
      const selectedStyles = styleFilters.filter((filter) => filter.checked).map((filter) => filter.value);
      categoryTabs.forEach((tab) => {
        const style = tab.dataset.refCategoryStyle || '';
        const active = style ? selectedStyles.length === 1 && selectedStyles[0] === style : selectedStyles.length === 0;
        tab.classList.toggle('active', active);
        if (active) tab.setAttribute('aria-current', 'page');
        else tab.removeAttribute('aria-current');
      });
    };

    const updateStyleUrl = () => {
      const selectedStyles = styleFilters.filter((filter) => filter.checked).map((filter) => filter.value);
      const url = new URL(window.location.href);
      if (selectedStyles.length === 1) url.searchParams.set('ira_style', selectedStyles[0]);
      else url.searchParams.delete('ira_style');
      url.hash = 'catalog-products';
      window.history.replaceState({}, '', url);
    };

    const apply = async () => {
      updateCounts();
      syncCategoryTabs();
      const selected = filters.filter((filter) => filter.checked);
      if (!selected.length) {
        grid.innerHTML = originalMarkup;
        if (count) count.textContent = originalCount;
        if (status) status.textContent = '';
        root.classList.remove('is-client-filtered');
        return;
      }
      root.classList.add('is-filtering', 'is-client-filtered');
      if (status) status.textContent = 'Filtering the complete collection…';
      try {
        const products = await loadProducts();
        const groups = selected.reduce((result, filter) => {
          const kind = filter.dataset.refClientFilter;
          (result[kind] ||= []).push(filter.value);
          return result;
        }, {});
        const matches = products.filter((product) => {
          const values = classify(product, root.dataset.collectionHandle);
          return Object.entries(groups).every(([kind, allowed]) => allowed.includes(slugify(values[kind])));
        });
        grid.replaceChildren(...matches.map(createCard));
        if (!matches.length) {
          const empty = document.createElement('p');
          empty.className = 'catalog-empty-message';
          empty.textContent = 'No pieces match this combination yet. Try removing one filter.';
          grid.append(empty);
        }
        if (count) count.textContent = `${matches.length} pieces · ${root.dataset.collectionTitle}`;
        if (status) status.textContent = matches.length ? `Showing ${matches.length} matching pieces from the full collection.` : '';
      } catch (_) {
        if (status) status.textContent = 'These filters could not load. The original collection is still available below.';
        grid.innerHTML = originalMarkup;
        if (count) count.textContent = originalCount;
      } finally {
        root.classList.remove('is-filtering');
      }
    };

    filters.forEach((filter) => filter.addEventListener('change', () => {
      if (filter.dataset.refClientFilter === 'style') updateStyleUrl();
      apply();
    }));

    categoryTabs.forEach((tab) => tab.addEventListener('click', (event) => {
      event.preventDefault();
      const requestedStyle = tab.dataset.refCategoryStyle || '';
      styleFilters.forEach((filter) => { filter.checked = requestedStyle !== '' && filter.value === requestedStyle; });
      updateStyleUrl();
      apply();
      root.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }));

    const requestedStyle = slugify(new URL(window.location.href).searchParams.get('ira_style') || '');
    const requestedFilter = styleFilters.find((filter) => filter.value === requestedStyle);
    if (requestedFilter) {
      requestedFilter.checked = true;
      apply();
    } else {
      syncCategoryTabs();
    }
  }

  const initPriceTabs = (root = document) => {
    const maximum = new URL(window.location.href).searchParams.get('filter.v.price.lte') || 'all';
    root.querySelectorAll('[data-ref-price-tab]').forEach((tab) => {
      const active = tab.dataset.refPriceTab === maximum;
      tab.classList.toggle('active', active);
      if (active) tab.setAttribute('aria-current', 'page');
      else tab.removeAttribute('aria-current');
    });
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-ref-enhanced-catalog]').forEach(init);
    initPriceTabs(root);
  };
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
